/* Testimonials archive: search + filter by B (Balance/Body/Building) and by product.
   Reads assets/testimonials.json (generated from the testimonials register - see
   reports/testimonials-search-2026-09-15/prototype/build-data.mjs). New file, does not
   touch any shared script. 2026-09-15. */
(function () {
  'use strict';

  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatDate(iso) {
    var parts = (iso || '').split('-');
    if (parts.length !== 3) return iso || '';
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var m = parseInt(parts[1], 10) - 1;
    var day = parseInt(parts[2], 10);
    return months[m] + ' ' + day + ', ' + parts[0];
  }

  function starString(n) {
    if (typeof n !== 'number') return '';
    return '★'.repeat(n) + '☆'.repeat(5 - n);
  }

  function normalize(s) {
    return (s || '').toString().toLowerCase();
  }

  function init(root) {
    var src = root.dataset.src;
    if (!src) return;

    var grid = root.querySelector('.js-testim-grid');
    var meta = root.querySelector('.js-testim-meta');
    var emptyState = root.querySelector('.testim-empty');
    var searchInput = root.querySelector('.js-testim-search');
    var productSelect = root.querySelector('.js-testim-product');
    var clearBtn = root.querySelector('.js-testim-clear');
    var bChips = Array.prototype.slice.call(root.querySelectorAll('.js-testim-b-chips .testim-chip'));

    var state = { q: '', b: null, product: '' };
    var ALL = [];

    function cardHtml(t) {
      var stars = typeof t.rating === 'number'
        ? '<span class="testim-stars" aria-label="' + t.rating + ' out of 5 stars">' + starString(t.rating) + '</span>'
        : '<span class="testim-stars" aria-hidden="true"></span>';

      var sourceLabel = t.sourceType === 'review' ? 'Review' : 'Message';
      var sourceClass = t.sourceType === 'review' ? '' : 'testim-source--message';

      var quoteId = 'testim-q-' + t.id;
      var paragraphs = (t.quote || '').split(/\n+/).filter(Boolean).map(function (p) {
        return '<p>' + escapeHtml(p) + '</p>';
      }).join('');

      var needsClamp = (t.quote || '').length > 320;

      var translationHtml = '';
      if (t.translation) {
        translationHtml = '<div class="testim-translation"><span class="testim-tlabel">Translation</span>' +
          t.translation.split(/\n+/).filter(Boolean).map(function (p) { return '<p>' + escapeHtml(p) + '</p>'; }).join('') +
          '</div>';
      }

      var productHtml = '';
      if (t.productUrl) {
        productHtml = '<a class="testim-product-link hub-link" href="' + t.productUrl + '">' + escapeHtml(t.product) + '</a>';
      } else if (t.product) {
        productHtml = '<span class="testim-no-product">' + escapeHtml(t.product) + '</span>';
      }

      var bTag = t.b ? '<span class="testim-b-tag">' + escapeHtml(t.b) + '</span>' : '';
      var dateStr = t.date ? formatDate(t.date) : '';

      return (
        '<li class="testim-card hub-card" data-id="' + t.id + '">' +
          '<div class="testim-card-top">' + stars + '<span class="testim-source ' + sourceClass + '">' + sourceLabel + '</span></div>' +
          '<blockquote id="' + quoteId + '" class="testim-quote' + (needsClamp ? ' testim-clamp' : '') + '">' + paragraphs + '</blockquote>' +
          (needsClamp ? '<button type="button" class="testim-readmore" data-target="' + quoteId + '" aria-expanded="false">Read more</button>' : '') +
          translationHtml +
          '<div class="testim-card-meta">' +
            '<span class="testim-person">' + escapeHtml(t.person) + '</span>' +
            productHtml +
            '<div class="testim-date-b">' + (dateStr ? '<span>' + dateStr + '</span>' : '') + bTag + '</div>' +
          '</div>' +
        '</li>'
      );
    }

    function matchesSearch(t, q) {
      if (!q) return true;
      var hay = [t.quote, t.translation, t.person, t.product, t.sourceLabel]
        .map(normalize).join(' \n ');
      return hay.indexOf(q) !== -1;
    }

    function filtered() {
      var q = normalize(state.q).trim();
      return ALL.filter(function (t) {
        if (!matchesSearch(t, q)) return false;
        if (state.b && t.b !== state.b) return false;
        if (state.product && t.product !== state.product) return false;
        return true;
      });
    }

    function render() {
      var list = filtered();
      if (meta) meta.textContent = 'Showing ' + list.length + ' of ' + ALL.length + ' stories';
      if (list.length === 0) {
        grid.innerHTML = '';
        if (emptyState) emptyState.hidden = false;
      } else {
        if (emptyState) emptyState.hidden = true;
        grid.innerHTML = list.map(cardHtml).join('');
      }
    }

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.testim-readmore');
      if (!btn) return;
      var target = document.getElementById(btn.dataset.target);
      if (!target) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        target.classList.add('testim-clamp');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'Read more';
      } else {
        target.classList.remove('testim-clamp');
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = 'Show less';
      }
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        state.q = searchInput.value;
        render();
      });
    }

    bChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var val = chip.dataset.b;
        var isActive = state.b === val;
        bChips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        state.b = isActive ? null : val;
        if (!isActive) chip.setAttribute('aria-pressed', 'true');
        render();
      });
    });

    if (productSelect) {
      productSelect.addEventListener('change', function () {
        state.product = productSelect.value;
        render();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state = { q: '', b: null, product: '' };
        if (searchInput) searchInput.value = '';
        if (productSelect) productSelect.value = '';
        bChips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        render();
      });
    }

    fetch(src, { credentials: 'omit' })
      .then(function (res) { return res.json(); })
      .then(function (payload) {
        ALL = Array.isArray(payload.testimonials) ? payload.testimonials : [];

        var products = {};
        ALL.forEach(function (t) { if (t.product) products[t.product] = true; });
        Object.keys(products).sort(function (a, b) { return a.localeCompare(b); }).forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = p;
          opt.textContent = p;
          productSelect.appendChild(opt);
        });

        render();
      })
      .catch(function () {
        if (meta) meta.textContent = 'Testimonials could not be loaded right now.';
      });
  }

  document.querySelectorAll('.js-testim-archive').forEach(init);
})();
